import React from 'react'
import { Container,Col, Row, Image } from "react-bootstrap";

function Parent({children,title1,title2}) {
  return (
    <div>
    <Container>
      <Row className="justify-content-center background-glass">
        <Col xs={12}>
           {children}
        </Col>
      </Row>
    </Container>
  </div>
  )
}

export default Parent